import React from "react";
import {
  DrawerHeader,
  DrawerCloseButton,
  Drawer,
  DrawerBody,
  Image,
  DrawerContent,
  Text,
  Box,
  VStack,
  Divider,
  HStack,
  Icon,
  DrawerOverlay,
  Button,
  Heading,
} from "@chakra-ui/react";
import { links } from "../../data/Navbar";
import logo from "../../assets/images/hLogo.png";
import {
  FaFacebook,
  FaXTwitter,
  FaYoutube,
  FaInstagram,
  FaTiktok,
} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

function NavbarDrawer({ isOpen, onClose }) {
  const nav = useNavigate();
  const handleInstagramClick = () => {
    window.open(
      "https://www.instagram.com/ideatorscup?igsh=aWdxMTI4c3I0d3Zm",
      "_blank"
    );
  };

  const formUrl =
    "https://forms.zohopublic.com/IDEATORSCUP/form/CYPRUSROUNDREGISTRATION/formperma/Tyx16DXRUfRvZhmvGzZIq3-AiDXmFma208KpF8Ib9S4";

  const handleRegisterClick = () => {
    window.open(formUrl, "_blank", "noopener,noreferrer");
  };
  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent bg="brand.150">
        <DrawerCloseButton
          color="brand.200"
          size="md"
          width="12px"
          height="12px"
          top="32px"
          right="16px"
        />
        <DrawerHeader px={4} py={6}>
          <Image src={logo} w="36px " h="32px"></Image>
        </DrawerHeader>

        <DrawerBody position="relative" pb={20}>
          <VStack spacing={4} align="stretch">
            {links.map((link, index) => (
              <Box key={index} w="100%" textAlign={"center"}>
                <Text
                  as="a"
                  onClick={(event) => {
                    event.preventDefault();
                    const sectionId = link.href.replace("/", "");
                    const section = document.getElementById(sectionId);

                    if (section) {
                      section.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                      onClose();
                    }
                  }}
                  color="white"
                  fontSize="18px"
                  fontWeight="600"
                  cursor="pointer"
                >
                  {link.label}
                </Text>
                <Divider m="auto" mt="4" w="16%" borderColor="white" />
              </Box>
            ))}
          </VStack>

          <Box display={"flex"} mt={12} justifyContent={"center"}>
            <Button
              borderRadius={"8px"}
              fontSize={"14px"}
              color="white"
              bg="black"
              onClick={handleRegisterClick}
            >
              Register Now
            </Button>
          </Box>

          {/* Social Media Icons Section (Fixed to Bottom) */}
          <Box
            position="absolute"
            bottom="20px"
            left="50%"
            transform="translateX(-50%)"
            textAlign="center"
            width="100%"
          >
            <Heading fontSize="12px" color="white" mb={2}>
              FOLLOW US ON :
            </Heading>
            <HStack spacing={4} justify="center">
              <Icon as={FaTiktok} boxSize={6} color="white" />
              <Icon as={FaFacebook} boxSize={6} color="white" />
              <Icon as={FaXTwitter} boxSize={6} color="white" />
              <Icon as={FaYoutube} boxSize={6} color="white" />
              <Icon
                as={FaInstagram}
                boxSize={6}
                color="white"
                onClick={handleInstagramClick}
                cursor={"pointer"}
              />
            </HStack>
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}

export default NavbarDrawer;
